import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';  // ✅ 페이지 이동을 위한 추가
// import '../asset/styles/RegistrationForm.css';
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'; // 스타일 추가
import translations from '../components/translations'; // 다국어 번역 파일
import logo from '../asset/images/day-drop-logo.svg'; // 로고 이미지
import timezones from '../config/timezones'; // ✅ 타임존 리스트 추가

const API_BASE_URL = "https://2epfk2ien9.execute-api.eu-west-2.amazonaws.com/prd"; // ✅ API Gateway URL

function RegistrationForm() {
    const navigate = useNavigate(); // ✅ 페이지 이동 함수 추가

    // ✅ UI 언어 상태 추가
    // const [language, setLanguage] = useState(localStorage.getItem("selectedLanguage") || "en");
    const [language, setLanguage] = useState(localStorage.getItem("selectedLanguage") || "EN-US");

    // ✅ 현재 언어가 translations에 없으면 기본값("EN-US") 사용
    const currentTranslations = translations[language] || translations["EN-US"];

    const [formData, setFormData] = useState({
        name: '',
        phoneNumber: '',
        nativeLanguage: language,
        preferredLanguage: language,
        nationality: '',
        optIn: true,
        preferredTimeStart: '09:00:00',
        preferredTimeEnd: '12:00:00',
        city: '',
        timezone: '',
    });

    const [errorMessage, setErrorMessage] = useState(""); // ✅ 에러 메시지 상태 추가

    const formatTimezone = (apiTimezone) => {
        if (!apiTimezone) return "UTC±00:00";
        return `UTC${apiTimezone}`; // ✅ "+09:00" → "UTC+09:00"
    };

    useEffect(() => {
        const fetchLocation = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/get-location`);
                const data = await response.json();
                console.log('📍 위치 정보:', data);
                setFormData((prevData) => ({
                    ...prevData,
                    city: data.city || '',
                    timezone: formatTimezone(data.timezone), // ✅ 변환된 값 설정
                    countryCode: '+82', // ✅ 기본 국가 코드 설정
                }));
            } catch (error) {
                console.error('❌ 위치 정보를 가져오는 데 실패:', error);
            }
        };

        fetchLocation();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        // ✅ Native Language 변경 시 UI 언어도 변경
        if (name === "nativeLanguage") {
            setLanguage(value);  // ✅ UI 언어 변경
            localStorage.setItem("selectedLanguage", value);  // ✅ 저장하여 새로고침 후에도 유지

            // ✅ 새로운 nativeLanguage에 맞는 preferredLanguage 목록 가져오기
            const availableLanguages = Object.keys(translations[value].countries);

            setFormData((prevData) => ({
                ...prevData,
                nativeLanguage: value,
                preferredLanguage: availableLanguages.includes(prevData.preferredLanguage)
                    ? prevData.preferredLanguage // ✅ 기존 값 유지 (존재하는 경우)
                    : availableLanguages[0], // ✅ 새로운 목록 중 첫 번째 값으로 변경
            }));
            return;
        }
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handlePhoneChange = (value) => {
        if (value) {
            const phoneNumber = parsePhoneNumber(value);
            if (phoneNumber) {
                const countryCode = `+${phoneNumber.countryCallingCode}`;
                const nationalNumber = phoneNumber.nationalNumber;

                setFormData((prevData) => ({
                    ...prevData,
                    phoneNumber: nationalNumber,
                    countryCode: countryCode,
                }));
            } else {
                // 유효하지 않은 전화번호 처리
                setFormData((prevData) => ({
                    ...prevData,
                    phoneNumber: '',
                    countryCode: '',
                }));
                console.error('유효하지 않은 전화번호입니다.');
            }
        } else {
            setFormData((prevData) => ({
                ...prevData,
                phoneNumber: '',
                countryCode: '',
            }));
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('📩 서버로 보낼 데이터:', formData);

        try {
            const response = await fetch(`${API_BASE_URL}/save-user`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log('✅ 서버 응답:', result);

            if (!response.ok) {
                setErrorMessage(result.message); // ✅ 에러 메시지 표시
                return;
            }

            if (result.statusCode === 200) {
                console.log('🔄 사용자 정보 저장 후 페이지 이동');
                localStorage.setItem("selectedLanguage", formData.nativeLanguage); // ✅ 모국어 상태값 저장
                // ✅ 사용자가 입력한 phone_number와 country_code를 localStorage에 저장
                localStorage.setItem("phone_number", formData.phoneNumber);
                localStorage.setItem("country_code", formData.countryCode);

                navigate("/subscription"); // ✅ 사용자 정보 저장 후 구독 플랜 페이지로 이동!
            }
        } catch (error) {
            console.error('❌ 사용자 정보 저장 실패:', error);
            setErrorMessage("❌ 네트워크 오류가 발생했습니다."); // ✅ 네트워크 에러 처리
        }
    };

    return (
        <div className="registration-form-container">
            <img src={logo} alt="Logo" className="logo" />

            {/*<h2>{translations[language].title}</h2>*/}

            {/* ✅ 에러 메시지가 있을 경우 화면에 표시 */}
            {errorMessage && <p className="error-message">{errorMessage}</p>}

            <form onSubmit={handleSubmit}>
                <label>{currentTranslations.name}*:
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required/>
                </label>

                <label>{currentTranslations.phoneNumber}*:
                    <PhoneInput
                        placeholder="전화번호를 입력하세요"
                        value={formData.countryCode + formData.phoneNumber}
                        onChange={handlePhoneChange}
                        defaultCountry="KR"
                        international
                        countryCallingCodeEditable={false} // ✅ 국가 코드 수정 불가
                    />
                </label>

                <label>{currentTranslations.nativeLanguage}*:
                    <select name="nativeLanguage" value={formData.nativeLanguage} onChange={handleChange} required>
                        {Object.keys(translations).map((code) => (
                            <option key={code} value={code}>{translations[code].nativeLanguage}</option>
                        ))}
                    </select>
                </label>

                <label>{currentTranslations.preferredLanguage}:
                    <select name="preferredLanguage" value={formData.preferredLanguage} onChange={handleChange}>
                        {Object.keys(currentTranslations.countries).map((code) => (
                            <option key={code} value={code}>{currentTranslations.countries[code]}</option>
                        ))}
                    </select>
                </label>

                <label>{currentTranslations.preferredTime}:
                    <select name="preferredTimeStart" value={formData.preferredTimeStart} onChange={handleChange}>
                        <option value="09:00:00">Morning (09:00 - 12:00)</option>
                        <option value="12:00:00">Afternoon (12:00 - 17:00)</option>
                        <option value="17:00:00">Evening (17:00 - 21:00)</option>
                    </select>
                </label>

                <label>{currentTranslations.city}:
                    <input type="text" name="city" value={formData.city} readOnly/>
                </label>

                <label>{currentTranslations.timezone}:
                    <select name="timezone" value={formData.timezone} onChange={handleChange}>
                        {timezones.map((tz) => (
                            <option key={tz.value} value={tz.value}>{tz.label}</option> // ✅ 지역명 포함
                        ))}
                    </select>
                </label>

                <div style={{ marginBottom: '20px' }}>
                    <input type="checkbox" id="optIn" name="optIn" checked={formData.optIn} onChange={handleChange}/>
                    <label htmlFor="optIn">{currentTranslations.optIn}</label>
                </div>

                <button type="submit">{currentTranslations.submit}</button>
            </form>
        </div>
    );
}

export default RegistrationForm;
